export default __webpack_public_path__ + "static/media/web-solo.svg";